import React from 'react'
import './styles.scss'
export const TitleBox = ({
    children
}: {
    children: React.ReactChild | React.ReactChild[]
}) => {
    return (
        <div className='Boxes Title'>
            <div className='ui text container'> <span className='mainblue'>{children && children}</span></div>
        </div>
    )
}

export const MapRelatedBox = ({
    children
}: {
    children: React.ReactChild | React.ReactChild[]
}) => {
    return <div className='Boxes Map'><div className='boxcontent'>{children && children}</div></div>
}

export const TextBox = ({
    children
}: {
    children: React.ReactChild | React.ReactChild[]
}) => {
    return (
        <div className='Boxes Text'>
            <div className='ui text container'>
                <div className='ta text'>{children && children}</div>
            </div>
        </div>
    )
}
